import React, { useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import axios from "axios";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { addProfileImage, login, userlogout } from "../../redux/userSlice";
import { resetTheme } from "../../redux/themeSlice";


const DefaultPasswordComponent = () => {
  const [showModal, setShowModal] = useState(false);
  const [hasLoggedIn, setHasLoggedIn] = useState(false);
  const APi_Url = process.env.REACT_APP_ENIGMA_API;
  const { email } = useParams(); // Extract email from URL
  const dispatch = useDispatch();
  const naviagtion = useNavigate();
  const [changePasswordStatus, setChangePasswordStatus] = useState(true);
  const initialValues = {
    firstName: "",
    lastName: "",
    new_Password: "",
    confirm_Password: "",
  };

  const validationSchema = Yup.object({
    new_Password: Yup.string()
      .min(6, "New password must be at least 6 characters")
      .required("Newpassword is Required"),
    confirm_Password: Yup.string()
      .oneOf([Yup.ref("new_Password"), null], "Passwords must match")
      .required("Confirm Password is Required"),
      firstName: Yup.string()
      .min(1, "First Name must be at least 1 characters")
      .test(
        "no-spaces",
        "First Name must not contain only spaces or excessive spaces",
        (value) => {
          return value && !/^\s+$/.test(value) && !/\s\s+/.test(value);
        }
      )
      .required("First Name is Required"),
      lastName: Yup.string()
      .min(1, "Last Name must be at least 1 characters")
      .test(
        "no-spaces",
        "Last Name must not contain only spaces or excessive spaces",
        (value) => {
          return value && !/^\s+$/.test(value) && !/\s\s+/.test(value);
        }
      )
      .required("Last Name is Required"),
  });

  // changePassword onsubmit function
  const onSubmit = async (values, { setSubmitting, resetForm }) => {
    const data = {
      email: email,
      password: values.new_Password,
      firstName:values.firstName,
      lastName:values.lastName,
      token: "4bd64e434292798ff43ae9707e0fb0625ec67333d6b283baa00dde26de01f8b0",
    };

    // console.log("form values",data);

    try {
      const response = await axios.post(
        `${APi_Url}api/auth/reset-default-password`,
        JSON.stringify(data),
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      );

     

      if (response?.data?.success == true) {
        toast.success("Successfully change password");
        setChangePasswordStatus(false);
        loginApi(values.new_Password);
      }
      resetForm();
    } catch (error) {
      console.error("Error ", error);
    } finally {
      setSubmitting(false); // Make sure to reset form state, if applicable
    }
  };

  

  const storeToken = (token) => {
    const tokenData = {
      value: token,
      timestamp: new Date().getTime(),
    };
    sessionStorage.setItem("token", JSON.stringify(tokenData));
  };
  const loginApi = async (Password) => {
    if (hasLoggedIn) return; // Prevent further login attempts

    setHasLoggedIn(true);
    dispatch(userlogout());
    dispatch(resetTheme());
    const logindata = {
      userName: email,
      password: Password,
    };
    try {
      const response = await axios.post(
        `${APi_Url}api/auth/login`,
        JSON.stringify(logindata),
        {
          headers: {
            Accept: "*",
            Accept: "application/json",
            "Content-Type": "application/json",
            secure: false,
            changeOrigin: true,
          },
        }
      );

      // console.log('Response:', response);
      // console.log('userDetails:', response.data.response.userDetails);
      // console.log('statsucode:', response.data.statusCode);
      const responseToken = response.data.response.token;
      const statusCode = response.data.statusCode;
      const userDetails = response.data.response.userDetails;
      // console.log("getusers",userDetails.getusers[0])
      if (statusCode === 200) {
        toast.success("Successfully Login");
        storeToken(responseToken);
        sessionStorage.setItem("userRole", userDetails.role);
              
        
        dispatch(
          login({
            user: {
              id: userDetails.userId,
              role: userDetails.role,
              userEmail: userDetails.userEmail,
              firstName: userDetails.getusers[0].firstName,
              lastName: userDetails.getusers[0].lastName,
              token: response.data.response.token,
            },
          })
        );
        dispatch(addProfileImage(userDetails.profileImageUrl));
        // dispatch(addAccountPriority('update'));
        setShowModal(false);
        if (userDetails.role == "Dev") {
          naviagtion("/dashboard");
        } else if (userDetails.role == "Admin") {
          naviagtion("/admin/user");
        }
      }
      // Handle response data as needed
    } catch (error) {
      setShowModal(false);
      if (error?.response?.data?.errorMassage[0]) {
        toast.error(error?.response?.data?.errorMassage[0]);
      }
    } finally {
      setShowModal(false);
    }
  };
  return (
    <>
      <section className="dashbordsect">
        {/* modal for change password start */}
        <div
          className={`modal fade inputmodal ${
            changePasswordStatus ? "show" : ""
          }`}
          aria-hidden="true"
          style={{ display: changePasswordStatus ? "block" : "none" }}
          tabIndex="-1"
          role="dialog"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h1>Change Password</h1>
              </div>
              <div className="modal-body">
                <Formik
                  initialValues={initialValues}
                  validationSchema={validationSchema}
                  onSubmit={onSubmit}
                >
                  {({ resetForm }) => (
                    <Form className="row needs-validation">
                      <div className="col-md-12">
                        {/* first name */}
                        {/* new password */}
                        <div className="row mb-3">
                          <label className="col-sm-5 col-form-label">
                           First Name
                          </label>
                          <div className="col-sm-7">
                            <Field
                              type="text"
                              id="firstName"
                              name="firstName"
                              placeholder="Input here"
                              className="form-control"
                            />
                            <ErrorMessage
                              name="firstName"
                              component="div"
                              className="error_msg"
                            />
                          </div>
                        </div>

                        {/* Last name */}

                        {/* new password */}
                        <div className="row mb-3">
                          <label className="col-sm-5 col-form-label">
                            Last Name
                          </label>
                          <div className="col-sm-7">
                            <Field
                              type="text"
                              id="lastName"
                              name="lastName"
                              placeholder="Input here"
                              className="form-control"
                            />
                            <ErrorMessage
                              name="lastName"
                              component="div"
                              className="error_msg"
                            />
                          </div>
                        </div>

                        {/* new password */}
                        <div className="row mb-3">
                          <label className="col-sm-5 col-form-label">
                            New password
                          </label>
                          <div className="col-sm-7">
                            <Field
                              type="password"
                              id="new_Password"
                              name="new_Password"
                              placeholder="Input here"
                              className="form-control"
                            />
                            <ErrorMessage
                              name="new_Password"
                              component="div"
                              className="error_msg"
                            />
                          </div>
                        </div>

                        {/* confirm password */}
                        <div className="row mb-3">
                          <label className="col-sm-5 col-form-label">
                            Confirm password
                          </label>
                          <div className="col-sm-7">
                            <Field
                              type="password"
                              id="confirm_Password"
                              name="confirm_Password"
                              placeholder="Input here"
                              className="form-control"
                            />
                            <ErrorMessage
                              name="confirm_Password"
                              component="div"
                              className="error_msg"
                            />
                          </div>
                        </div>
                      </div>

                      <div className="col-12">
                        <button className="btn kevlar_btn" type="submit">
                          Submit
                        </button>
                      </div>
                      {/* <div className="col-12">
                      <button
                        className="btn kevlar_btn"
                        type="button"
                        onClick={() => {
                          setChangePasswordStatus(false);
                          resetForm();
                        }}
                      >
                        Cancel
                      </button>
                    </div> */}
                    </Form>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </div>
        {/* modal for change password end */}
      </section>
    </>
  );
};

export default DefaultPasswordComponent;
